import {
  Popover as HuiPopover,
  PopoverButton,
  PopoverPanel,
} from "@headlessui/react";
import { Fragment, type ReactElement, type ReactNode } from "react";

import { cn } from "./cn";
import { SHEET_PANEL, useSheet } from "./sheet";

interface PopoverProps {
  trigger: ReactNode;
  /** Функция получает close — так содержимое может закрыть поповер само,
   *  например после выбора значения. */
  children: ReactNode | ((props: { close: () => void }) => ReactElement);
  align?: "start" | "end";
  className?: string;
}

const PANEL = "z-50 rounded-md border border-line bg-raised p-3 shadow-md focus:outline-none";

export function Popover({ trigger, children, align = "start", className }: PopoverProps) {
  // На телефоне — нижний лист (sheet.ts). Классы вызывающего кода остаются
  // (фон, отступы), размеры и положение перебивает лист.
  const sheet = useSheet();
  return (
    <HuiPopover>
      {/* as={Fragment} — см. комментарий в Menu.tsx: обёртка <div>
          с display:contents не передавала клик и открывала кнопку
          внутри кнопки. */}
      <PopoverButton as={Fragment}>{trigger}</PopoverButton>
      <PopoverPanel
        {...(sheet
          ? { portal: true, className: cn(className ?? PANEL, SHEET_PANEL) }
          : {
              anchor: { to: align === "end" ? "bottom end" : "bottom start", gap: 6 } as const,
              className: className ?? PANEL,
            })}
      >
        {children}
      </PopoverPanel>
    </HuiPopover>
  );
}
